import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './video-carousel.component.scss';
var VideoCarousel = /** @class */ (function (_super) {
    tslib_1.__extends(VideoCarousel, _super);
    function VideoCarousel(element) {
        return _super.call(this, element) || this;
    }
    VideoCarousel.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderItems = this.element.querySelectorAll('.video-carousel-item');
        this.windowWidth = document.documentElement.clientWidth;
        this.sliderConfig = {
            preventClicks: false,
            preventClicksPropagation: false,
            slidesPerView: 3,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.6,
                    spaceBetween: 30,
                },
                768: {
                    initialSlide: 0,
                    slidesPerView: 2.4,
                    spaceBetween: 20,
                },
                576: {
                    initialSlide: 0,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    VideoCarousel.prototype.bindEvents = function () { };
    return VideoCarousel;
}(Base));
export { VideoCarousel };



//////////////////
// WEBPACK FOOTER
// ./components/video-carousel/video-carousel.component.ts
// module id = 557
// module chunks = 0